import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { vars } from 'utils/variables';

export const LinkListWrap = styled.section`
  width: 100%;
  padding: 16px 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;

export const MenuList = styled.ul`
  margin-left: 24px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LinkWrap = styled.li`
  height: 20px;
  border: none;
  outline: none;

  &:hover *,
  &:active * {
    color: ${vars.primaryHover};
    fill: ${vars.primaryHover};
  }
`;

export const NavItem = styled(NavLink)`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  cursor: pointer;
  pointer-events: all;
`;

export const MenuTitle = styled.h6`
  color: ${vars.dark70};
  line-height: 20px;
  text-transform: uppercase;

  transition: color ${vars.transitionTimingFunction};
`;

export const ToolsIcon = styled.svg`
  width: 16px;
  height: 16px;

  fill: ${vars.dark70};
  transition: fill ${vars.transitionTimingFunction};
`;
